<nb-card class="h-100">
  <nb-card-body class="body-page">
    <div class="row">
      <simple-audio-player #audioPlayer></simple-audio-player>
    </div>
  </nb-card-body>
</nb-card>
